import React, { useCallback, useEffect } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import useDebounce from '~/hooks/useDebounce';
import { useSearch } from '../../../../SearchContext';
import { SearchBarContainer } from '../../styles';

export const SearchBar: React.FC = () => {
  const toUpper = useCallback(
    (s: string) => (s ?? '').toLocaleUpperCase('pt-BR'),
    [],
  );

  const {
    showTable,
    inputSearch,
    setValue,
    loading,
    searchBarPlaceholder,
    searchBarValue,
    setSearchBarValue,
    handleSearchBarFilter,
    disableSearch,
    searchBarInputRef,
  } = useSearch();

  const { debouncedFn } = useDebounce();

  useEffect(() => {
    setValue('shouldClearFilter', false);
  }, [loading, setValue]);

  // Limpa o valor da search bar quando sai da visualização da tabela
  // useEffect(() => {
  //   if (!showTable) {
  //     setSearchBarValue('');
  //   }
  // }, [showTable, setSearchBarValue]);

  const handleSearchChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const input = event.target;
      const { selectionStart } = input;

      const upper = toUpper(input.value);
      setSearchBarValue(upper);

      requestAnimationFrame(() => {
        if (input.setSelectionRange && selectionStart !== null) {
          input.setSelectionRange(selectionStart, selectionStart);
        }
      });

      // Usa debounce para evitar muitas requisições
      debouncedFn(() => {
        handleSearchBarFilter(upper);
      }, 500);
    },
    [setSearchBarValue, handleSearchBarFilter, debouncedFn, toUpper],
  );

  const clearSearch = useCallback(() => {
    setSearchBarValue('');
    handleSearchBarFilter('');
  }, [setSearchBarValue, handleSearchBarFilter]);

  return (
    <SearchBarContainer showTable={showTable}>
      <FaSearch />
      <input
        ref={searchBarInputRef}
        type="text"
        className="search"
        disabled={disableSearch}
        placeholder={searchBarPlaceholder || 'Buscar...'}
        value={showTable ? searchBarValue : toUpper(inputSearch)}
        onInput={handleSearchChange}
        readOnly={!showTable}
      />
      {searchBarValue && showTable && (
        <FaTimes
          onClick={clearSearch}
          style={{
            position: 'absolute',
            right: '40px',
            cursor: 'pointer',
            fontSize: '14px',
            color: '#666',
            zIndex: 15,
          }}
        />
      )}
    </SearchBarContainer>
  );
};
